export enum ROUTES {
  CUSTOMER_STUDIES_LIST = 'customers',
  DISPATCHED_STUDIES_LIST = 'dispatches',
  ERROR = 'error',
  LOGIN = 'ingreso',
  STUDIES_LIST = 'studies',
  STUDY = 'study',
  STUDY__FORM = 'form',
  STUDY__INFO = 'info',
  STUDY__HISTORY = 'history',
}

export const AUTH_HOME_ROUTE = ROUTES.STUDIES_LIST;
export const UNAUTH_HOME_ROUTE = ROUTES.LOGIN;
